"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Environment = exports.CCFieldType = exports.PaymentTab = exports.FuelType = void 0;
var tslib_1 = require("tslib");
var FuelType;
(function (FuelType) {
    FuelType["Gas"] = "Gas";
    FuelType["Electricity"] = "Electricity";
})(FuelType = exports.FuelType || (exports.FuelType = {}));
var PaymentTab;
(function (PaymentTab) {
    PaymentTab[PaymentTab["CreditOrDebitCard"] = 0] = "CreditOrDebitCard";
    PaymentTab[PaymentTab["PayPal"] = 1] = "PayPal";
})(PaymentTab = exports.PaymentTab || (exports.PaymentTab = {}));
var CCFieldType;
(function (CCFieldType) {
    CCFieldType["CardNumber"] = "card-number";
    CCFieldType["Cvv"] = "cvv";
    CCFieldType["Expiry"] = "expiry";
})(CCFieldType = exports.CCFieldType || (exports.CCFieldType = {}));
var Environment;
(function (Environment) {
    Environment["Production"] = "production";
    Environment["UAT"] = "uat";
})(Environment = exports.Environment || (exports.Environment = {}));
(0, tslib_1.__exportStar)(require("./PaymentEnum"), exports);
(0, tslib_1.__exportStar)(require("./GoogleAnalytics"), exports);
//# sourceMappingURL=index.js.map